import ProviderWrapper from "./src/store/wrapper";
import "./src/styles/global.css";
import "./src/utils/firebase";

export const wrapRootElement = ProviderWrapper;
